/**
 * Long poll a fetch request until the 202 status code is resolved
 * @param fn - The fetch function to long poll
 * @returns The response from the fetch
 */
export async function longPollFetch(fn) {
    const response = await fn();
    if (response.status === 202) {
        // Fetch resource again on 202 untill it's resolved
        return longPollFetch(fn);
    }
    return response;
}
